import { render, staticRenderFns } from "./open_class.vue?vue&type=template&id=2001fa98&scoped=true"
import script from "./open_class.vue?vue&type=script&lang=js"
export * from "./open_class.vue?vue&type=script&lang=js"
import style0 from "./open_class.vue?vue&type=style&index=0&id=2001fa98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2001fa98",
  null
  
)

export default component.exports